import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { Root } from './ConflictReportInfo.css';
import PageTitle from '../Layout/components/PageTitle';
import { Paper, Tabs, Tab, Table, TableHead, TableRow, Link, TableCell, TableBody, TableFooter, TablePagination, Button, Dialog, TextField, Breadcrumbs, Typography, Grid } from '@material-ui/core';
import { roleStr, defaultPageSize, isRole, ROLES, ADD, VIEW, EDIT, ONGOING, COMPLETED, DISABLED } from '../../common/common';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { BASE_URL } from '../../store/config';
import instance from '../../request/http';
import ReportInfo from './components/ReportInfo';
import AlertDialog from '../Layout/components/AlertDialog';
import Search from '@material-ui/icons/Search'
import { getUrlParams, timeFormat } from '../../common/utils';
import PersonList from '../ConflictReport/components/PersonList';
import Toast from '../Layout/components/Toast';
import TaskCard from './components/TaskCard';

class ConflictReportInfo extends PureComponent {
    constructor(props) {
        super(props);
        const id = getUrlParams("id");
        this.state = {
            id: id,
            reference_number: 1000,
            status: "ongoing",
            create_time: "2021-04-21T16:21:03.787325+08:00",
            update_time: "2021-04-21T16:21:03.787325+08:00",
            client: {
                first_name: "奥术大师多",
                last_name: "a's'da",
                full_name: "奥术大师多 a's'da",
                email: "d's'd",
                wechat: "null",
                phone: "a's'da's",
                relation: "null"
            },
            related_persons: [],
            tasks: [
                {
                    name: "Intranet",
                    description: "null",
                    principal_id: "null",
                    principal_name: "null",
                    result: [
                        {
                            person_name: "奥术大师多 a's'da",
                            relation: null,
                            is_existed: false,
                            similar_clients: []
                        }
                    ],
                    status: "completed"
                },
                {
                    name: "ssseeesss",
                    description: "ddddd",
                    principal_id: 41,
                    principal_name: "deptaccount",
                    result: {
                        is_existed: "null",
                        notes: "null"
                    },
                    status: "ongoing"
                }
            ],
            showToast: false,
            toastMsg: "",
            toastState: "",
        }
        this.handleCreate = this.handleCreate.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
        this.updateMember = this.updateMember.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }
    render() {
        const { title, state } = this.props;
        const {
            id,
            reference_number,
            status,
            create_time,
            update_time,
            client,
            related_persons,
            tasks,
            showToast,
            toastMsg,
            toastState,
        } = this.state;

        console.log(reference_number, tasks);
        const btns = () => {
            if (state !== VIEW) {
                return <Button
                    className="btn"
                    variant="contained"
                    color="primary"
                    onClick={this.handleCreate}
                >
                    {state === ADD ? 'create' : 'save'}
                </Button>
            }
        }
        const statusView = (status) => {
            if (status === ONGOING) {
                return <div className="basic-status color-1 c">Ongoing</div>
            } else if (status === COMPLETED) {
                return <div className="basic-status color-2 c">Completed</div>
            } else if (status === DISABLED) {
                return <div className="basic-status color-3 c">Disabled</div>
            } else {
                return <div>--</div>
            }
        }
        return (
            <Root>
                <div className="head h">
                    <div className="v">
                        <PageTitle subtitle="MANAGEMENT"></PageTitle>
                        <Breadcrumbs separator="›" aria-label="breadcrumb">
                            <Link className="title" onClick={() => this.props.history.goBack()}>All Report</Link>
                            <Typography className="crtTitle">{reference_number}</Typography>
                        </Breadcrumbs>
                    </div>
                </div>
                <div className="content-wrap">
                    {/* <div className="page-title">Report Info</div> */}
                    <div className="item-wrap">
                        <div className="title-2">Report Info</div>
                        <Grid container>
                            <Grid item xs={12} sm={2}>
                                <div className="text-title">Reference Number</div>
                                <div>{reference_number}</div>
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <div className="text-title">Status</div>
                                <div>{statusView(status)}</div>
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <div className="text-title">Create time</div>
                                <div>{timeFormat(create_time)}</div>
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <div className="text-title">Update time</div>
                                <div>{timeFormat(update_time)}</div>
                            </Grid>
                        </Grid>
                    </div>
                    <div className="item-wrap">
                        <div className="title-2">Client Info</div>
                        <Grid container>
                            <Grid item xs={12} sm={2}>
                                <div className="text-title">First Name</div>
                                <div>{client.first_name}</div>
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <div className="text-title">Last Name</div>
                                <div>{client.last_name}</div>
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <div className="text-title">Email</div>
                                <div>{client.email}</div>
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <div className="text-title">Phone</div>
                                <div>{client.phone}</div>
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <div className="text-title">Wechat</div>
                                <div>{client.wechat}</div>
                            </Grid>
                        </Grid>
                    </div>
                    <div className="item-wrap">
                        <div className="title-2">Related Persons</div>
                        <Table stickyHeader className="table">
                            <TableHead>
                                <TableRow role="checkbox">
                                    <TableCell>Person Name</TableCell>
                                    <TableCell>Relation</TableCell>
                                    <TableCell>Email</TableCell>
                                    <TableCell>Phone</TableCell>
                                    <TableCell>Wechat</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {related_persons.map((row, index) => (
                                    <TableRow key={index} role="checkbox">
                                        <TableCell>{row.full_name}</TableCell>
                                        <TableCell>{row.relation}</TableCell>
                                        <TableCell>{row.email}</TableCell>
                                        <TableCell>{row.phone}</TableCell>
                                        <TableCell>{row.wechat}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                    <div className="item-wrap">
                        <div className="title-2">Tasks</div>
                        <div className="flow">
                            {tasks.map((row, index) => (
                                <TaskCard
                                    key={index}
                                    data={row}
                                ></TaskCard>
                            ))}
                        </div>
                    </div>
                </div>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
            </Root>
        )
    }
    componentDidMount() {
        const { id } = this.state;
        this.getReport(id, (data) => {
            console.log(data.tasks);
            this.setState(() => ({
                reference_number: data.reference_number,
                status: data.status,
                create_time: data.create_time,
                update_time: data.update_time,
                client: data.client,
                related_persons: data.related_persons,
                tasks: data.tasks,
            }));
        });
    }
    updateMember(member) {
        if (!member) return;
        const user_ids = [];
        user_ids.push(member.id);
        this.setState({
            user_ids
        })
    }
    handleChange(e) {
        const { value, name } = e.target;
        this.setState((prevState) => ({
            client: {
                ...prevState.client,
                [name]: value
            }
        }));
    }
    handleCreate() {
        const { client } = this.state;
        const related_persons = this.personList.getData();
        this.props.handleCreate(client, related_persons);
    }
    handleClose() {
        this.props.handleCancel();
    }
    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }
    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }
    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
    //------------request-----------------
    getReport(report_id, callback = null) {
        instance.get(BASE_URL + `conflict/report/${report_id}`).then((res) => {
            const reportData = res.data.data;
            console.log(reportData)
            if (callback) callback(reportData);
        })
    }
}

export default withRouter(ConflictReportInfo);